import Loading from "@components/loading/Loading";

const UtilsProvider = ({
  children,
}: Readonly<{ children: React.ReactNode }>) => {
  return (
    <>
      <Loading />
      {children}
    </>
  );
};

export default UtilsProvider;
